import React from "react";
import HeroSection from "./HeroSection";
import {Helmet} from "react-helmet";
import { useEffect } from "react";
import sal from "sal.js";
import ApplystartButtonComponent from '../../components/ApplystartButtonComponent';
import ContactUsFormSection from "../contactUsView/ContactUsFormSection";
export const UkView = () => {
    useEffect(() => {
        sal();
    }, []);


    // HERO BANNER
    const backgroundImage = require("../../assets/images/views/ukView/ukBannerB.jpg");
    const flag = require("../../assets/images/views/ukView/ukBannerA.png");

    return (

        <>
            <Helmet>
                <title>{"Study in the UK: Apply hassle-free with Applystart"}</title>
                <meta name={"description"}
                      content={"Explore the benefits of studying in the USA, find study loans, scholarships, and expert consultants to guide you. Start your journey to academic excellence today."}/>
                <meta property={"og:title"} content={"Study in the USA: Apply with Applystart"}/>
                <meta property={"og:description"}
                      content={"Explore the benefits of studying in the USA, find study loans, scholarships, and expert consultants to guide you. Start your journey to academic excellence today."}/>
            </Helmet>

            <HeroSection
                backgroundImage={backgroundImage}
                flag={flag}
                heading={"Study in the United Kingdom"}
                headingStyle={"bannerWhiteRed"}
                subHeading={"Board the flight of your dreams with Applystart "}
                caption={"The UK education system opens doors to a world of opportunities. From bustling cities to historic campuses, it offers a unique blend of academic rigor and vibrant student life that shapes future global leaders."}
                floaties={["022d", "079b", "099"]}
            />

            <div className="container mt-5 pt-5 mb-5 pb-5">
                <h2>We're preparing informative content about studying in the UK</h2>
                <div className="row">
                    <div className="col-md-6 mb-5 pb-5">
                        <p>In the meantime, here are some useful resources:</p>
                        <h3>Counselling for UK</h3>
                        <p>Book a counselling session with Applystart to get started with your application journey in the UK:</p>
                        <ApplystartButtonComponent text="Book a counselling session" link="https://calendly.com/applystart-advisingteam/new-students-advising-session-with-applystart" external={true} theme="primary"/>
                        <br/><br/><hr style={{borderTop: "0.5px solid var(--color-secondary)", opacity: "0.3", marginBottom:"40px"}}/>
                        <h3>Request Programs</h3>
                        <p>Request program recommendations to get a personalized list of programs according to your preferences:</p>
                        <ApplystartButtonComponent text="Program Request Form" link="https://docs.google.com/forms/d/e/1FAIpQLSf6ANttUF1ZnDInLTrH9AGTCoR4jAu_24YHSHLlP7KdgOZL6Q/viewform " external={true} theme="primary"/>
                    </div>
                    <div className="col-md-6">
                        <div className="contact-form form-style-2">
                            <div className="section-title">
                                <h4 className="title">Get In Touch</h4>
                                <p>Let us know if you have any questions about studying in the UK.</p>
                            </div>
                            <ContactUsFormSection />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}